import classNames from "classnames"
import React, { ComponentProps } from "react"

export type ButtonProps = {
  color: "primary" | "secondary" | "tertiary"
  children: React.ReactNode
  onClick?: () => void
  className?: string
} & ComponentProps<"button">

export const Button: React.FC<ButtonProps> = ({
  color,
  children,
  onClick,
  className: externalClassName,
  ...props
}) => {
  const internalClassName = classNames(
    "rounded-full text-main-light text-sm px-3 h-6 font-semibold text-nowrap block print:border print:bg-main-light print:border-main-700 print:text-main-dark",
    {
      "bg-primary-500": color === "primary",
      "bg-secondary-500": color === "secondary",
      "bg-main-200 !text-main-dark": color === "tertiary",
    }
  )

  const combinedClassName = classNames(internalClassName, externalClassName)

  return (
    <button className={combinedClassName} onClick={onClick} {...props}>
      {children}
    </button>
  )
}
